
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/onboarding",
      function () {
        return require("private-next-pages/onboarding.js");
      }
    ]);
  